// extracted by mini-css-extract-plugin
export default {"Container":"table__Container__f843t"};